import { LocationQuery, RouteParams } from 'vue-router';
import { OfertaResource } from '@/models/resources';
import { queryStringService } from '@/services';

type RouteParamORQuery = RouteParams[string] | LocationQuery[string];
export const popQueryOrParam = (queryOrParam?: RouteParamORQuery): string | undefined => {
  if (!queryOrParam) return undefined;

  if (!Array.isArray(queryOrParam)) return queryOrParam;

  return queryOrParam.pop() ?? undefined;
};

export const normalizePropagatedQuery = (query: LocationQuery | null | undefined) => {
  const sanitizedQuery = Object.entries(query ?? {})
    .map(([key, value]) => [key, popQueryOrParam(value)]);

  return {
    ...queryStringService.getFromStorage(),
    ...Object.fromEntries(sanitizedQuery),
  };
};

export const normalizeIntIdRouteParam = (id = 'NaN') => {
  const idNum = parseInt(id, 10);
  return Number.isNaN(idNum) ? undefined : idNum;
};

export const normalizeOfertaIdParam = (ofertaId?: OfertaResource['id'] | null) => {
  if (ofertaId == null || ofertaId === '') return undefined;
  return OfertaResource.normalizeId(ofertaId);
};

export default {
  popQueryOrParam,
  normalizePropagatedQuery,
  normalizeIntIdRouteParam,
  normalizeOfertaIdParam,
};
